module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Food/Bottle#2-bd764afd256c80a1673753a1f4eb620df0e1cca67c84605cbdff5c06d3ba67e6.svg";